import { useTheme } from "@emotion/react";
import { useMediaQuery } from "@mui/material";
// should be wrapped around components that can only be viewed
// on desktop and larger devices
export default function DesktopViewer({ children }) {
  const theme = useTheme();
  const isLargeScreen = !useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = !useMediaQuery(theme.breakpoints.down("sx"));
  return isLargeScreen && isMediumScreen ? children : null;
}
